// Color values live in src/index.css (:root and [data-theme] blocks).
export const themes = [
  { id: "midnight", name: "Dark" },
  { id: "daylight", name: "Light" },
];

export const DEFAULT_THEME = "midnight";
export const THEME_STORAGE_KEY = "portfolio-theme";
